// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flex_pZhD3 {
  height : 100%;
}

.divider_ZOnv3 {
  align-self: stretch;
  border-bottom: 1px solid var( --color-base100 );
}

.mobileTopNav_uLK86,
.mobileUserNav_sXDnO {
  overflow: unset !important;
}

.top_Gz5yL {
  flex : 0 0;
}
.bottom_tOis3 {
  flex : 0 0;
  margin-top: auto;
}

.middle_IuVoV {
  flex : 1 1 auto;
  overflow : scroll !important;
}

.hidden_yHk4s {
  overflow : hidden;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/main/actions/ShowMainNav.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".flex {\n  height : 100%;\n}\n\n.divider {\n  align-self: stretch;\n  border-bottom: 1px solid var( --color-base100 );\n}\n\n.mobileTopNav,\n.mobileUserNav {\n  overflow: unset !important;\n}\n\n.top {\n  flex : 0 0;\n}\n.bottom {\n  flex : 0 0;\n  margin-top: auto;\n}\n\n.middle {\n  flex : 1 1 auto;\n  overflow : scroll !important;\n}\n\n.hidden {\n  overflow : hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flex": `flex_pZhD3`,
	"divider": `divider_ZOnv3`,
	"mobileTopNav": `mobileTopNav_uLK86`,
	"mobileUserNav": `mobileUserNav_sXDnO`,
	"top": `top_Gz5yL`,
	"bottom": `bottom_tOis3`,
	"middle": `middle_IuVoV`,
	"hidden": `hidden_yHk4s`
};
export default ___CSS_LOADER_EXPORT___;
